export default __webpack_public_path__ + "static/media/poly.01c746e8.png";